// src/pages/termOfPayments/EditTermOfPayments.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditTermOfPayments from "../../components/termOfPayments/FormAddEditTermOfPayments";
import useGetTermOfPayment from "../../hooks/termOfPayments/useGetTermOfPayment";

const EditTermOfPayments = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { isLoading, termOfPayment } = useGetTermOfPayment(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTermOfPayments
                isEdit={true}
                currentData={termOfPayment}
                onSubmitSuccess={() => navigate("/term-of-payments")}
            />
        </WrapperSection>
    );
};

export default EditTermOfPayments;